import { useContext, useEffect, useState } from "react";
import {
  Dialog,
  DialogPanel,
  Disclosure,
  PopoverGroup,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, useNavigate } from "react-router-dom";
import { fetchData, ThemeContext } from "@/context/ContextFile";
import ModalLogin from "@/Pages/ModalLogin";
import RegisterModal from "../RegisterModal";
import ProfileMenu from "./ProfileMenu";
import {
  BUSINESS_TYPES,
  LODGING_TYPES_DROPDOWN,
  SPACE_TYPES_DROPDOWN,
} from "@/constants";
import Swal from "sweetalert2";
import { FaPlane } from "react-icons/fa6";
import { Business } from "@mui/icons-material";

export default function TailwindHeader(props) {
  const { profile = false } = props || {};
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  // let { setIsRegister, setIsModalOpen } = useContext(ThemeContext);
  const { isModalOpen, setIsModalOpen, isRegister, setIsRegister } =
    useContext(ThemeContext);
  const token = localStorage.getItem("token");

  const handleAdvertising = () => {
    navigate("/advertise");
  };

  const GetData = (name, key) => {
    navigate(`/map_listing/${name}/${key}`);
  };

  const [isFixed, setIsFixed] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsFixed(true);
    } else {
      setIsFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <header
        className={`bg-white p-5 w-full  transition-all duration-300 ${
          isFixed ? "fixed top-0 shadow-md" : "relative"
        }`}
        style={{ zIndex: 100 }}
      >
        <nav
          aria-label="Global"
          className="flex items-center justify-between px-4 mx-auto lg:px-8"
        >
          <div className="hidden lg:flex-1 md:flex">
            {/* {logo && ( */}
            <Link to={"/"}>
              <img className="w-20 h-20" src="/image/fly-inn-logo.svg" alt="" />
            </Link>
            {/* )} */}
          </div>

          <Link to={"/"} className="flex lg:hidden">
            <img className="w-20 h-20" src="/image/fly-inn-logo.svg" alt="" />
          </Link>
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon aria-hidden="true" className="size-6" />
            </button>
          </div>

          <PopoverGroup className=" lg:flex lg:gap-x-12 relative z-[1000]">
            <div className="nav-holder main-menu relative z-[1000]">
              <nav>
                <ul className="no-list-style ">
                  <li>
                    <Link to="/" className="link">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="">
                      Explore <i className="fa fa-caret-down" />
                    </Link>
                    <ul className="!min-w-[200px]">
                      <li>
                        <Link to="#">
                          By Type
                          <i className="fa fa-caret-down" />
                        </Link>
                        <ul className="specific-ul !min-w-[200px] !h-auto !overflow-hidden">
                          <li>
                            <Link
                              onClick={() => fetchData()}
                              to="/listing"
                              className="link"
                            >
                              Stays
                            </Link>
                          </li>
                          <li className="!min-w-[200px]">
                            <Link
                              // onClick={() => fetchData()}
                              to="/directory"
                              className="link !min-w-[200px]"
                            >
                              Directory
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="#">
                          By Lodging
                          <i className="fa fa-caret-down" />
                        </Link>
                        <ul className="specific-ul !h-auto !overflow-hidden">
                          {LODGING_TYPES_DROPDOWN.map((item, index) => (
                            <li key={index}>
                              <Link
                                to={`/map_listing/${item.type}/${item.name}`}
                              >
                                {item.text || item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                      <li>
                        <Link to="#">
                          By Space
                          <i className="fa fa-caret-down" />
                        </Link>
                        {/*third  level  */}
                        <ul className="specific-ul !h-auto !overflow-hidden">
                          {SPACE_TYPES_DROPDOWN.map((item, index) => (
                            <li key={index}>
                              <Link
                                to={`/map_listing/${item.type}/${item.name}`}
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="#" className="">
                      Info <i className="fa fa-caret-down" />
                    </Link>
                    <ul>
                      <li>
                        <Link to="/about">About</Link>
                      </li>
                      <li>
                        <Link to="/faq">FAQ</Link>
                      </li>
                      <li>
                        <Link to="/philanthropy">Philanthropy</Link>
                      </li>
                      <li>
                        <Link to="/squawks">Squawks</Link>
                      </li>
                      <li>
                        <Link to="/agreements">
                          Agreements
                          <i className="fa fa-caret-down" />
                        </Link>
                        <ul>
                          <li>
                            <Link to={"/terms-of-service"}>
                              Terms of Service
                            </Link>
                          </li>
                          <li>
                            <Link to={"/privacy_policy"}>Privacy Policy</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/gallery">Gallery</Link>
                      </li>
                      <li>
                        <Link to="/testimonials">Testimonials</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <Link to="/contact" className="link">
                      Contact
                    </Link>
                  </li>

                  <li>
                    <div>
                      <Link
                        style={{
                          color: "#fff",
                          backgroundColor: "#af2322",
                          top: "0px",
                        }}
                        to="/login"
                        className={`add-list color-bg `}
                      >
                        Become a Host
                        <span style={{ paddingLeft: "0px" }}>
                          <i
                            style={{ color: "#fff" }}
                            className="fal fa-layer-plus"
                          ></i>
                        </span>
                      </Link>
                    </div>
                  </li>
                  <li onClick={handleAdvertising}>
                    <div>
                      <button
                        style={{
                          top: "0px",
                        }}
                        className={`add-list color-bg bg-[#8Ec639] !text-white`}
                      >
                        Advertise
                        <span style={{ paddingLeft: "0px" }}>
                          <i className="ms-1 fa fa-bullhorn !text-white"></i>
                        </span>
                      </button>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          </PopoverGroup>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end md:block">
            {profile && <ProfileMenu />}
          </div>
        </nav>
        <Dialog
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
          className="lg:hidden"
        >
          <div className="fixed inset-0 z-10" />
          <DialogPanel className="fixed inset-y-0 right-0 z-[1000] w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="relative z-50 flex items-center justify-between">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>

            <div className="flow-root mt-6">
              <nav>
                <ul className="space-y-4 no-list-style">
                  {/* Home Section */}
                  <li>
                    <Link className="text-lg font-bold text-black" to="/">
                      Home
                    </Link>
                  </li>

                  {/* Explore Section */}
                  <li>
                    <Disclosure>
                      {({ open }) => (
                        <>
                          <Disclosure.Button className="flex items-center justify-between w-full p-2 text-left bg-gray-200 rounded-md">
                            <span>Explore</span>
                            <i
                              className={`fa ${
                                open ? "fa-chevron-up" : "fa-chevron-down"
                              }`}
                            ></i>
                          </Disclosure.Button>
                          <Disclosure.Panel>
                            <ul className="pl-4 space-y-2 !list-none">
                              <li>
                                <Disclosure>
                                  {({ open }) => (
                                    <>
                                      <Disclosure.Button className="flex items-center justify-between w-full p-2 mt-2 text-left bg-gray-100 rounded-md">
                                        <span>By Type</span>
                                        <i
                                          className={`fa ${
                                            open
                                              ? "fa-chevron-up"
                                              : "fa-chevron-down"
                                          }`}
                                        ></i>
                                      </Disclosure.Button>
                                      <Disclosure.Panel>
                                        <ul className="pl-4 space-y-1 list-none">
                                          <li className="text-black">
                                            <Link
                                              // onClick={() => fetchData()}
                                              to="/listing"
                                              className="text-black link"
                                            >
                                              Stays
                                            </Link>
                                          </li>

                                          <li className="!min-w-[200px]">
                                            <Link
                                              // onClick={() => fetchData()}
                                              to="/directory"
                                              className="link !min-w-[200px]"
                                            >
                                              Directory
                                            </Link>
                                          </li>
                                        </ul>
                                      </Disclosure.Panel>
                                    </>
                                  )}
                                </Disclosure>
                              </li>

                              {/* By Lodging */}
                              <li>
                                <Disclosure>
                                  {({ open }) => (
                                    <>
                                      <Disclosure.Button className="flex items-center justify-between w-full p-2 mt-2 text-left bg-gray-100 rounded-md">
                                        <span>By Lodging</span>
                                        <i
                                          className={`fa ${
                                            open
                                              ? "fa-chevron-up"
                                              : "fa-chevron-down"
                                          }`}
                                        ></i>
                                      </Disclosure.Button>
                                      <Disclosure.Panel>
                                        <ul className="pl-4 space-y-1 list-none">
                                          {LODGING_TYPES_DROPDOWN.map(
                                            (item, index) => (
                                              <li
                                                key={index}
                                                className="text-black"
                                              >
                                                <Link
                                                  className="text-black"
                                                  to={`/map_listing/${
                                                    item.type
                                                  }/${encodeURIComponent(
                                                    item.name
                                                  )}`}
                                                >
                                                  {item.text || item.name}
                                                </Link>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </Disclosure.Panel>
                                    </>
                                  )}
                                </Disclosure>
                              </li>

                              {/* By Space */}
                              <li>
                                <Disclosure>
                                  {({ open }) => (
                                    <>
                                      <Disclosure.Button className="flex items-center justify-between w-full p-2 text-left bg-gray-100 rounded-md">
                                        <span>By Space</span>
                                        <i
                                          className={`fa ${
                                            open
                                              ? "fa-chevron-up"
                                              : "fa-chevron-down"
                                          }`}
                                        ></i>
                                      </Disclosure.Button>
                                      <Disclosure.Panel>
                                        <ul className="pl-4 space-y-1">
                                          <li
                                            onClick={() =>
                                              GetData(
                                                "entireplace",
                                                "byTypeOfSpace"
                                              )
                                            }
                                          >
                                            <Link to="#" className="text-black">
                                              Entire Place
                                            </Link>
                                          </li>
                                          <li
                                            onClick={() =>
                                              GetData(
                                                "private room",
                                                "byTypeOfSpace"
                                              )
                                            }
                                          >
                                            <Link to="#" className="text-black">
                                              Private Room
                                            </Link>
                                          </li>
                                          <li
                                            onClick={() =>
                                              GetData(
                                                "shared room",
                                                "byTypeOfSpace"
                                              )
                                            }
                                          >
                                            <Link to="#" className="text-black">
                                              Shared Room
                                            </Link>
                                          </li>
                                        </ul>
                                      </Disclosure.Panel>
                                    </>
                                  )}
                                </Disclosure>
                              </li>
                            </ul>
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  </li>

                  {/* Info Section */}
                  <li>
                    <Disclosure>
                      {({ open }) => (
                        <>
                          <Disclosure.Button className="flex items-center justify-between w-full p-2 text-left bg-gray-200 rounded-md">
                            <span>Info</span>
                            <i
                              className={`fa ${
                                open ? "fa-chevron-up" : "fa-chevron-down"
                              }`}
                            ></i>
                          </Disclosure.Button>
                          <Disclosure.Panel>
                            <ul className="pl-4 space-y-2 !list-none">
                              <li>
                                <Link className="text-black" to="/about">
                                  About
                                </Link>
                              </li>
                              <li>
                                <Link to="/faq" className="text-black">
                                  FAQ
                                </Link>
                              </li>
                              <li>
                                <Link className="text-black" to="/philanthropy">
                                  Philanthropy
                                </Link>
                              </li>
                              <li>
                                <Link className="text-black" to="/squawks">
                                  Squawks
                                </Link>
                              </li>
                              <li>
                                <Disclosure>
                                  {({ open }) => (
                                    <>
                                      <Disclosure.Button className="flex items-center justify-between w-full p-2 text-left bg-gray-100 rounded-md">
                                        <Link to="/agreements">
                                          <span>Agreements</span>
                                        </Link>
                                        <i
                                          className={`fa ${
                                            open
                                              ? "fa-chevron-up"
                                              : "fa-chevron-down"
                                          }`}
                                        ></i>
                                      </Disclosure.Button>
                                      <Disclosure.Panel>
                                        <ul className="pl-4 space-y-2 !list-none">
                                          <li>
                                            <Link
                                              className="text-black"
                                              to="/terms-of-service"
                                            >
                                              Terms of Service
                                            </Link>
                                          </li>
                                          <li>
                                            <Link
                                              className="text-black"
                                              to="/privacy_policy"
                                            >
                                              Privacy Policy
                                            </Link>
                                          </li>
                                        </ul>
                                      </Disclosure.Panel>
                                    </>
                                  )}
                                </Disclosure>
                              </li>
                              <li>
                                <Link className="text-black" to="/gallery">
                                  Gallery
                                </Link>
                              </li>
                              <li>
                                <Link className="text-black" to="/testimonials">
                                  Testimonials
                                </Link>
                              </li>
                            </ul>
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  </li>

                  {/* Contact Section */}
                  <li>
                    <Link className="text-black" to="/contact">
                      Contact
                    </Link>
                  </li>

                  {/* Become a Host Section */}
                  <li>
                    <Link
                      to="/login"
                      style={{
                        color: "#fff",
                        backgroundColor: "#af2322",
                        padding: "10px 20px",
                        borderRadius: "5px",
                      }}
                      className="flex items-center justify-center text-center"
                    >
                      Become a Host
                      <i className="pl-2 text-white fal fa-layer-plus"></i>
                    </Link>
                  </li>

                  <li onClick={handleAdvertising}>
                    <div>
                      <button
                        style={{
                          top: "0px",
                        }}
                        className={`add-list color-bg bg-[#8Ec639] !text-white`}
                      >
                        Advertise
                        <span style={{ paddingLeft: "0px" }}>
                          <i className="ms-1 fa fa-bullhorn !text-white"></i>
                        </span>
                      </button>
                    </div>
                  </li>

                  {/* <li>
                    <Link to={"/flight-plan"} className="!p-0">
                      <div>
                        <button
                          style={{
                            top: "0px",
                          }}
                          className={`add-list color-bg bg-[#3182ce] !text-white`}
                        >
                          Flight Plan
                          <span style={{ paddingLeft: "0px" }}>
                            <FaPlane className="inline ms-2" />
                          </span>
                        </button>
                      </div>
                    </Link>
                  </li> */}
                  <li>
                    <Link to={"/directory"} className="!p-0">
                      <div>
                        <button
                          style={{
                            top: "0px",
                          }}
                          className={`add-list color-bg bg-[#ff9900] !text-white`}
                        >
                          Directory
                          <span style={{ paddingLeft: "0px" }}>
                            <Business className="inline ms-2" />
                          </span>
                        </button>
                      </div>
                    </Link>
                  </li>

                  {!token && (
                    <>
                      <li>
                        <button
                          onClick={() => {
                            setMobileMenuOpen(false);
                            setIsModalOpen(true);
                          }}
                          style={{
                            color: "#fff",
                            backgroundColor: "#8Ec639",
                            padding: "10px 20px",
                            borderRadius: "5px",
                          }}
                          className="flex items-center justify-center w-full text-center"
                        >
                          Login
                        </button>
                      </li>

                      <li onClick={handleAdvertising}>
                        <div>
                          <button
                            style={{
                              top: "0px",
                            }}
                            className={`add-list color-bg bg-[#8Ec639] !text-white`}
                          >
                            Advertise
                            <span style={{ paddingLeft: "0px" }}>
                              <i className="ms-1 fa fa-bullhorn !text-white"></i>
                            </span>
                          </button>
                        </div>
                      </li>

                      <li>
                        <button
                          onClick={() => {
                            setMobileMenuOpen(false);
                            setIsRegister(true);
                          }}
                          style={{
                            color: "#fff",
                            backgroundColor: "#8Ec639",
                            padding: "10px 20px",
                            borderRadius: "5px",
                          }}
                          className="flex items-center justify-center w-full text-center"
                        >
                          Register
                        </button>
                      </li>
                    </>
                  )}

                  <li>
                    <Link to={"/flight-plan"} className="!p-0">
                      <div>
                        <button
                          style={{
                            color: "#fff",
                            backgroundColor: "#3182ce",
                            padding: "10px 20px",
                            borderRadius: "5px",
                          }}
                          className="flex items-center justify-center w-full text-center"
                        >
                          Flight Plan
                          <span style={{ paddingLeft: "0px" }}>
                            <FaPlane className="inline text-white ms-2" />
                          </span>
                        </button>
                      </div>
                    </Link>
                  </li>

                  <li>
                    <Link to={"/directory"} className="!p-0">
                      <div>
                        <button
                          style={{
                            color: "#fff",
                            backgroundColor: "#ff9900",
                            padding: "10px 20px",
                            borderRadius: "5px",
                          }}
                          className="flex items-center justify-center w-full text-center"
                        >
                          Directory
                          <span style={{ paddingLeft: "0px" }}>
                            <Business className="inline ms-2 text-white" />
                          </span>
                        </button>
                      </div>
                    </Link>
                  </li>

                  <li>
                    <Link to={"/advertise"} className="!p-0">
                      <div>
                        <button
                          style={{
                            color: "#fff",
                            padding: "10px 20px",
                            borderRadius: "5px",
                          }}
                          className="flex bg-[#8Ec639] items-center justify-center w-full text-center"
                        >
                          Advertise
                        </button>
                      </div>
                    </Link>
                  </li>

                  {token && (
                    <li>
                      <Link
                        to="/profile"
                        style={{
                          color: "#fff",
                          backgroundColor: "#8Ec639",
                          padding: "10px 20px",
                          borderRadius: "5px",
                        }}
                        className="flex items-center justify-center text-center"
                      >
                        Profile
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      {isModalOpen ? (
        <>
          <ModalLogin
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isRegister={isRegister}
            setIsRegister={setIsRegister}
          />
        </>
      ) : null}
      {isRegister ? (
        <>
          <RegisterModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isRegister={isRegister}
            setIsRegister={setIsRegister}
          />
        </>
      ) : null}
    </>
  );
}
